// eslint-disable-next-line import/prefer-default-export
export const allFilterBrands = [
	{
		name: 'ТОП-БРЕНДЫ',
		key: 'top',
	},
	{
		name: 'A',
	},
	{
		name: 'B',
	},
	{
		name: 'C',
	},
	{
		name: 'D',
	},
	{
		name: 'E',
	},
	{
		name: 'F',
	},
	{
		name: 'G',
	},
	{
		name: 'H',
	},
	{
		name: 'I',
	},
	{
		name: 'J',
	},
	{
		name: 'K',
	},
	{
		name: 'L',
	},
	{
		name: 'M',
	},
	{
		name: 'N',
	},
	{
		name: 'O',
	},
	{
		name: 'P',
	},
	{
		name: 'Q',
	},
	{
		name: 'R',
	},
	{
		name: 'S',
	},
	{
		name: 'T',
	},
	{
		name: 'U',
	},
	{
		name: 'V',
	},
	{
		name: 'W',
	},
	{
		name: 'X',
	},
	{
		name: 'Y',
	},
	{
		name: 'Z',
	},
	{
		name: '0-9',
		key: 'number',
	},
	{
		name: 'А-Я',
		key: 'ru',
	},
	{
		name: 'ВСЕ',
		key: 'all',
	},
];
